(function () {
  function includesComing(model) {
    return model.toLowerCase().includes("coming");
  }

  function escapeHtml(value) {
    return String(value).replace(/[&<>"']/g, (char) => {
      const entities = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#039;",
      };
      return entities[char];
    });
  }

  function renderBrandMark(item) {
    if (item.logo) {
      return `
        <div class="brand-logo">
          <img src="${escapeHtml(item.logo)}" alt="${escapeHtml(item.brand)} logo" loading="lazy">
        </div>
      `;
    }

    return `<div class="brand-initial" aria-hidden="true">${escapeHtml(item.brand.slice(0, 1).toUpperCase())}</div>`;
  }

  function renderModelRow(label, models, showNone = false) {
    if (!models.length && !showNone) return "";

    const chips = models.length
      ? models
          .map((model) => {
            const comingClass = includesComing(model) ? " is-coming" : "";
            return `<span class="model-chip${comingClass}">${escapeHtml(model)}</span>`;
          })
          .join("")
      : '<span class="model-none">None</span>';

    return `
      <div class="model-row">
        <span class="model-type">${label}</span>
        <div class="model-chips">${chips}</div>
      </div>
    `;
  }

  function initCompatibleEvModels(root = document) {
    const sections =
      root.matches && root.matches(".models-section")
        ? [root]
        : Array.from(root.querySelectorAll(".models-section"));

    sections.forEach((section) => {
      if (section.__compatibleEvModelsCleanup) {
        section.__compatibleEvModelsCleanup();
      }

      const modelGrid = section.querySelector("#modelGrid");
      const modelSearch = section.querySelector("#modelSearch");
      const filterButtons = section.querySelectorAll(".filter-tabs button");

      if (!modelGrid || !modelSearch || !filterButtons.length || !window.CompatibleEvData) return;

      const compatibleBrands = window.CompatibleEvData.load()
        .slice()
        .sort((a, b) => a.brand.localeCompare(b.brand, undefined, { sensitivity: "base" }));
      let activeFilter = "all";

      function getVisibleModels(item, type, query) {
        const list = type === "pure_ev" ? item.pureEv : item.phev;
        const brandMatches = item.brand.toLowerCase().includes(query);

        return list.filter((model) => {
          const matchesSearch = !query || brandMatches || model.toLowerCase().includes(query);
          const matchesType =
            activeFilter === "all" ||
            activeFilter === type ||
            (activeFilter === "coming" && includesComing(model));

          return matchesSearch && matchesType;
        });
      }

      function renderModels() {
        const query = modelSearch.value.trim().toLowerCase();

        const cards = compatibleBrands
          .map((item) => {
            const visibleBev = getVisibleModels(item, "pure_ev", query);
            const visiblePhev = getVisibleModels(item, "phev", query);
            const showNone =
              activeFilter === "all" &&
              (!query || item.brand.toLowerCase().includes(query)) &&
              !item.phev.length;

            if (!visibleBev.length && !visiblePhev.length && !showNone) return "";

            return `
              <article class="model-card">
                <header class="model-card-header">
                  ${renderBrandMark(item)}
                  <div>
                    <h3>${escapeHtml(item.brand)}</h3>
                  </div>
                </header>
                <div class="model-card-body">
                  ${renderModelRow("Pure EV", visibleBev)}
                  ${renderModelRow("PHEV", visiblePhev, showNone)}
                </div>
              </article>
            `;
          })
          .filter(Boolean);

        if (!cards.length) {
          modelGrid.innerHTML =
            '<div class="empty-state">No matching vehicle found. Try a brand, model name, or switch the Pure EV / PHEV filter.</div>';
          return;
        }

        modelGrid.innerHTML = cards.join("");
      }

      const handleSearch = () => renderModels();
      modelSearch.addEventListener("input", handleSearch);

      const filterHandlers = [];
      filterButtons.forEach((button) => {
        const handleFilterClick = () => {
          activeFilter = button.dataset.filter;
          filterButtons.forEach((item) => item.classList.toggle("active", item === button));
          renderModels();
        };
        filterHandlers.push([button, handleFilterClick]);
        button.addEventListener("click", handleFilterClick);
      });

      section.__compatibleEvModelsCleanup = () => {
        modelSearch.removeEventListener("input", handleSearch);
        filterHandlers.forEach(([button, handler]) => {
          button.removeEventListener("click", handler);
        });
      };

      renderModels();
    });
  }

  window.initCompatibleEvModels = initCompatibleEvModels;

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => initCompatibleEvModels());
  } else {
    initCompatibleEvModels();
  }

  document.addEventListener("shopify:section:load", (event) => {
    initCompatibleEvModels(event.target);
  });
})();
